import { AccountInfo, AuthenticationResult } from "@azure/msal-browser";
import { createContext, useContext } from "react";
import { StoreApi, useStore } from "zustand";

export interface AuthenticationInformation {
  status: AuthenticationStatus;
  account?: AccountInfo | null;
}

export interface AuthenticationActions {
  onRedirect: () => Promise<string | undefined>;
  signInSilent: () => Promise<void>;
  signIn: (from?: string) => Promise<void>;
  signOut: () => Promise<void>;
  signUp: () => Promise<void>;
  getRequestToken: () => Promise<AuthenticationResult>;
}

export interface AuthenticationStore extends AuthenticationInformation, AuthenticationActions {}
export const AuthenticationContext = createContext<StoreApi<AuthenticationStore> | null>(null);

export enum AuthenticationStatus {
  NotAuthenticated = 'NotAuthenticated',
  Authenticating = 'Authenticating',
  Authenticated = 'Authenticated',
  Error = 'Error'
}

export function useAuthentication<U>(selector: (store: AuthenticationStore) => U): U {
  const context = useContext(AuthenticationContext);
  if (!context) {
    throw new Error('useAuthentication must be used within a AuthenticationProvider');
  }
  return useStore(context, selector);
}